import { Component, Inject, OnInit } from '@angular/core';
import { MD_DIALOG_DATA, MdDialog, MdDialogRef } from '@angular/material';

import { AppMessage } from './../../../Common/appMessage';
import { Utility } from './../../../Common/Services/utility';
import { AdmBlacklistExamService } from './adm-blacklist-exam.service';

@Component({
  selector: 'app-adm-blacklist-exam',
  templateUrl: './adm-blacklist-exam.component.html',
  styleUrls: ['./adm-blacklist-exam.component.css'],
  providers: [AdmBlacklistExamService]
})
export class AdmBlacklistExamComponent implements OnInit {

  examData: any;
  locationId: number;
  formattedExamData: any;
  alphabets: any;
  undoAllExamisBlacklisted: boolean;
  doAllExamisBlacklisted: boolean;
  isSelectExam: boolean;
  selectedChar: string;
  constructor(
    public dialogRef: MdDialogRef<AdmBlacklistExamComponent>,
    @Inject(MD_DIALOG_DATA) public data: any,
    private _blackListService: AdmBlacklistExamService, public _utility: Utility, public _dialog: MdDialog, private _appMessage: AppMessage
  ) {
    this.locationId = data;

  }

  ngOnInit() {
    this.formattedExamData = [];
    this.selectedChar = '#';
    this.alphabets = [];
    this.alphabets.push('#'); // First char is #
    this.undoAllExamisBlacklisted = false;
    this.doAllExamisBlacklisted = false;
    this.isSelectExam = false;
    /**
     * push characters into array
     * Get all chars from its char code
     */
    for (let i = 65; i <= 90; i++) {
      this.alphabets.push(String.fromCharCode(i));
    }
    this.getBlackListExam();
  }

  getBlackListExam() {
    this._utility.addLoaderCount();
    this._blackListService.getExamList(this.locationId).subscribe(response => {
      this._utility.onSuccessCallback(response, null, () => {
        this.examData = response.response.results;
        this.getFormattedExamData();
      });
    }, error => this._utility.onErrorCallback(error));

  }

  /**
   * This function return formatted data which we have required to create dyanamic layout
   * Design > [{label: 'A', data: [{examCode: 101, examName: 'testexam', isBlacklisted : true}]}]
   */
  getFormattedExamData() {
    for (let i = 0; i < this.examData.length; i++) {
      let item = this.examData[i];
      let examName = item.examName;
      let firstChar = examName.substring(0, 1).toUpperCase();
      let labels = this.formattedExamData.map(function (item) { return item.label; });

      /**
       * If Char Label already exist in array then only Push exam data
       * Else create a new Label and then push exam data into Data object of formattedExamData array
       */
      if (labels.indexOf(firstChar) > -1) {
        let specificItem = this.formattedExamData.find(function (item) { if (item.label == firstChar) return item });
        specificItem.data.push({ 'examId': item.examId, 'examName': examName, 'isBlacklisted': item.isBlacklisted });
      } else {
        this.formattedExamData.push({ 'label': firstChar, 'data': [{ 'examId': item.examId, 'examName': examName, 'isBlacklisted': item.isBlacklisted }] });
      }
    }
    if (this.formattedExamData && this.formattedExamData.length > 0) {
      this.formattedExamData.sort(function (item1, item2) { if (item1.label > item2.label) { return 1 } else { return -1 } })
    }
  }

  /**
   * If clicked on select all checkbox then Update isBlacklisted property of examdata true for all records else make it false.
   * @param isChecked : value of select all and  unselect all
   */
  checkedExam(isChecked: boolean) {
    let data = this.formattedExamData.map(function (item) { return item.data; });
    data.forEach(element => {
      if (element && element.length > 0) {
        element.forEach(subElement => {
          subElement.isBlacklisted = isChecked;
        });
      }
    });
  }

  onSelectAll(checked: boolean) {
    if (checked) {
      this.checkedExam(true);
      this.undoAllExamisBlacklisted = false;
    } else {
      this.checkedExam(false);
    }
  }

  onUnSelectAll(checked: boolean) {
    this.checkedExam(false);
    this.doAllExamisBlacklisted = false;
  }

  onUpdate() {
    let instance = this._dialog.openDialogs[0];
    this._dialog.openDialogs.pop();//to clear instance of first dialog box to opne another on it(issue i IE,edge and safari) 
    let blacklistExams = [];

    for (let i = 0; i < this.formattedExamData.length; i++) {
      let item = this.formattedExamData[i];
      if (item.data.length > 0) {
        for (let j = 0; j < item.data.length; j++) {
          let examObj = item.data[j];
          blacklistExams.push({ examId: examObj.examId, isBlacklisted: examObj.isBlacklisted });
        }
      }
    }

    let params = {
      locationId: Number(this.locationId),
      blacklistExams: blacklistExams
    }
    this._blackListService.updateBlacklistExam(params).subscribe(response => {
      this._utility.onSuccessCallback(response, this._appMessage.getItem['UMsg00029'], () => {
        this.closeDialog();
      });
    }, error => { this.closeDialog(); this._utility.onErrorCallback(error) });
    this._dialog.openDialogs.push(instance); //popped instance pushed again to maintain its normal behavior
  }

  // To close the current dialog
  closeDialog(dialogResult: any = 0) {
    this.dialogRef.close(dialogResult);
  }
}



// WEBPACK FOOTER //
// /opt/app-root/src/src/app/Components/adm-manage-location-setting/adm-blacklist-exam/adm-blacklist-exam.component.ts